import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";
import Detail from "./Details";

import { PositionProvider } from "../../../context/PositionContext";

export const Cinema = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddCinema = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditCinema = () => {
  return (
    
      
        <Edit />
      
    
  );
};

export const ViewCinema = () => {
  return (
    
      <Detail />
    
  );
};
